<div class="p-4">
    <breadcrumb [items]="breadcrumb"></breadcrumb>
    <mat-spinner class="mx-auto my-5" *ngIf="loading"></mat-spinner>

    <mat-card>
        <mat-card-content *ngIf="!loading">
            <div class="d-flex align-items-end mb-3">
                <h1 class="fs-3 fw-light mb-0">Faturamento {{ faturamento.contrato.nome }}</h1>
                <ng-container>      
                    <button mat-icon-button color="primary" class="d-print-none btn-sm ms-auto">
                        <mat-icon>tune</mat-icon>
                    </button>              
                    <button mat-flat-button class="d-print-none ms-3 bg-gray-400" (click)="print()">IMPRIMIR</button>
                    <button mat-flat-button color="primary" class="d-print-none ms-3" [matMenuTriggerFor]="menu">EXPORTAR</button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="export('pdf')">PDF</button>
                        <button mat-menu-item (click)="export('csv')">Excel</button>
                    </mat-menu>
                </ng-container>
            </div>
            <div class="row" *ngIf="!loading">                
                <div class="col-12 mb-2">
                    <mat-divider></mat-divider>
                </div>
                <div class="col-12 col-md-4 mb-3">
                    <span class="fw-bold fs-7 opacity-50">DATA BASE INICIO</span>
                    <div class="lh-sm">{{ faturamento.dataBaseInicio ? (faturamento.dataBaseInicio | date:'dd/MM/yyyy') : '---' }}</div>
                </div>
                <div class="col-12 col-md-4 mb-3">
                    <span class="fw-bold fs-7 opacity-50">DATA BASE FIM</span>
                    <div class="lh-sm">{{ faturamento.dataBaseFim ? (faturamento.dataBaseFim | date:'dd/MM/yyyy') : '---' }}</div>
                </div>
                <div class="col-12 col-md-4 mb-3">
                    <span class="fw-bold fs-7 opacity-50">STATUS</span>
                    <div class="lh-sm">
                        <span class="status-badge text-bg-secondary fs-7 py-1">{{ faturamento.status }}</span>
                    </div>
                </div>

                <!-- LISTA DE DIOS -->
                <generate-table [dataSource]="dataSource" [columns]="columns" [loading]="loading" [total]="pagination.total"
                    [pageSize]="pagination.pageSize" (pageEvent)="search($event)"></generate-table>

                <div class="col-12 mb-3">
                    <mat-divider></mat-divider>
                </div>                
            </div>

            <div class="col-12 col-md-3" *ngIf="faturamento.status === 'CONCLUIDO'">
                <div>
                    <mat-form-field class="w-100">
                        <mat-label>Justificativa Reabertura</mat-label>
                        <textarea type="textarea" rows="8" matInput name="motivo" [(ngModel)]="justificativaReabertura"></textarea>
                    </mat-form-field>
                </div>
                <button mat-flat-button color="primary" class="btn-lg w-100"
                    [disabled]="loading" (click)="reabrir()">
                    <mat-spinner class="btn-spinner" *ngIf="loading"></mat-spinner>
                    <span *ngIf="!loading">REABRIR FATURAMENTO</span>
                </button>                
            </div>
            <div class="col-12 col-md-3" *ngIf="faturamento.status === 'REABERTO'">
                <button mat-flat-button color="primary" class="btn-lg w-100"
                    [disabled]="loading" (click)="fechar()">
                    <mat-spinner class="btn-spinner" *ngIf="loading"></mat-spinner>
                    <span *ngIf="!loading">FECHAR FATURAMENTO</span>
                </button>                
            </div>
        </mat-card-content>
    </mat-card>
</div>
